module.exports = __webpack_public_path__ + "img/konfigurator_kobieta.345a25a7.svg";